<template>
  <!-- <div> -->
  <Dropdown :style="{width: '100%', position: 'relative'}" class="customDrop" trigger="click">
    <Input
      @on-clear="clear"
      clearable
      icon="ios-arrow-down"
      placeholder="请选择所属区域"
      readonly
      type="text"
      v-model="name"
    >
      <!-- <Icon type="ios-arrow-down" slot="suffix" /> -->
    </Input>
    <DropdownMenu slot="list">
      <div class="regionPanel">
        <Tabs @click="changeType" v-model="type">
          <TabPane label="省" name="province">
            <div class="regionContainer">
              <div
                :class="'regionItem' + (provinceCode == region.fullCode?' active':'')"
                :key="region.code"
                @click="changeProvice(region)"
                v-for="region in regionData"
              >{{region.name}}</div>
            </div>
          </TabPane>
          <TabPane label="市" name="city">
            <div class="regionContainer">
              <div
                :class="'regionItem' + (cityCode == region.fullCode?' active':'')"
                :key="region.code"
                @click="changeCity(region)"
                v-for="region in cityData"
              >{{region.name}}</div>
            </div>
          </TabPane>
          <TabPane label="区" name="county">
            <div class="regionContainer">
              <div
                :class="'regionItem' + (countyCode == region.fullCode?' active':'')"
                :key="region.code"
                @click="changeCounty(region)"
                v-for="region in countyData"
              >{{region.name}}</div>
            </div>
          </TabPane>
          <TabPane label="街道" name="street">
            <div class="regionContainer">
              <div
                :class="'regionItem' + (streetCode == region.fullCode?' active':'')"
                :key="region.code"
                @click="changeStreet(region)"
                v-for="region in streetData"
              >{{region.name}}</div>
            </div>
          </TabPane>
        </Tabs>
      </div>
    </DropdownMenu>
  </Dropdown>
  <!-- </div> -->
</template>
<script>
export default {
  name: 'regionSelect',
  props: {
    location: [],
  },
  data () {
    return {
      type: '',
      name: '',
      regionData: [],
      provinceName: '',
      provinceCode: '',
      cityData: [],
      cityName: '',
      cityCode: '',
      countyData: [],
      countyName: '',
      countyCode: '',
      streetData: [],
      streetName: '',
      streetCode: ''
    }
  },
  watch: {
    location: {
      immediate: true,
      deep: true,
      handler: function (newValue, oldValue) {
        console.log("newValue", newValue)
        this.getLabel()
      }
    }
  },
  computed: {

    regionCodes: function () {
      let codes = []
      if (this.provinceCode) codes.push(this.provinceCode)
      if (this.cityCode) codes.push(this.cityCode)
      if (this.countyCode) codes.push(this.countyCode)
      if (this.streetCode) codes.push(this.streetCode)
      return codes
    },
  },
  methods: {
    regionName: function () {
      let names = []

      if (this.provinceName) {
        names.push(this.provinceName)
      }
      if (this.cityName) names.push(this.cityName)
      if (this.countyName) names.push(this.countyName)
      if (this.streetName) names.push(this.streetName)
      console.log("names", names)
      return names.join(' / ')
    },
    reset: function (value) {
      this.provinceName = ''
      this.provinceCode = ''
      this.cityData = []
      this.cityName = ''
      this.cityCode = ''
      this.countyData = []
      this.countyName = ''
      this.countyCode = ''
      this.streetData = []
      this.streetName = ''
      this.streetCode = ''
      if (value) {
        if (value[0]) this.provinceCode = value[0]
        if (value[1]) this.cityCode = value[1]
        if (value[2]) this.countyCode = value[2]
        if (value[3]) this.streetData = value[3]
      }
    },
    changeType: function (val) {
      this.type = val
    },
    changeProvice: function (region) {
      this.provinceName = region.name
      this.provinceCode = region.fullCode
      this.cityData = region.children
      this.countyData = []
      this.streetData = []
      this.changeType('city')
      this.name = this.regionName()

      this.$emit('change', this.regionCodes)
    },
    changeCity: function (region) {
      this.cityName = region.name
      this.cityCode = region.fullCode
      this.countyData = region.children
      this.streetData = []
      this.changeType('county')
      this.name = this.regionName()
      this.$emit('change', this.regionCodes)
    },
    changeCounty: function (region) {
      this.countyName = region.name
      this.countyCode = region.fullCode
      this.streetData = region.children
      this.changeType('street')
      this.name = this.regionName()
      this.$emit('change', this.regionCodes)
    },
    changeStreet: function (region) {
      this.streetName = region.name
      this.streetCode = region.fullCode
      this.name = this.regionName()
      this.$emit('change', this.regionCodes)
    },
    clear: function () {
      this.name = ''
      this.$emit('change', [])
    },
    getLabel: function () {
      let that = this
      this.reset(this.location)
      console.log(that.provinceCode)
      console.log(that.cityCode)
      console.log(that.countyCode)
      console.log(that.streetCode)
      this.regionData.forEach(provice => {
        if (provice.fullCode == that.provinceCode) {
          that.provinceName = provice.name
          that.cityData = provice.children || []

          that.cityData.forEach(city => {
            if (city.fullCode == that.cityCode) {
              that.cityName = city.name
              that.countyData = city.children || []

              that.countyData.forEach(county => {
                if (county.fullCode == that.countyCode) {
                  that.countyName = county.name
                  that.streetData = county.children || []
                  that.streetData.forEach(street => {
                    if (street.fullCode == that.streetCode) {
                      that.streetName = street.name
                    }
                  })
                }
              })
            }
          })
        }
      })
      this.name = this.regionName()
    },
    initTree: function () {
      let that = this
      this.$axios.post(that.$apis.dictionaryManager.region.getTree).then(res => {
        if (res.success) {
          that.regionData = res.result || []
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error('区域数据获取失败！')
      }).then(val => {
        that.getLabel()
      })
    }
  },
  beforeMount () {
    this.initTree()
  }
}
</script>
<style scoped>
.regionPanel {
  /* height: 50vh; */
  /* overflow-y: auto; */
  padding: 0 1rem;
}

.regionContainer {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}

.regionContainer .regionItem {
  /* flex: 1; */
  line-height: 1;
  cursor: pointer;
  width: 8rem;
  min-width: 8rem;
  padding: 1rem;
  white-space: nowrap;
}

.regionContainer .regionItem:hover,
.regionContainer .regionItem.active {
  color: #2d8cf0;
}
</style>